import React from 'react';
import { useMobileChart } from '../../context/MobileChartContext';

interface MetricTriggerProps {
  label: string;
  value: string | number | React.ReactNode;
  chartComponent: React.ReactNode;
  className?: string;
}

/**
 * A component that displays a financial metric and triggers a chart overlay on mobile
 * when tapped. On desktop, this component does not change the existing behavior.
 */
const MetricTrigger: React.FC<MetricTriggerProps> = ({
  label,
  value,
  chartComponent,
  className = '',
}) => {
  const { isMobile, openChart } = useMobileChart();
  
  const handleClick = () => {
    if (isMobile) {
      openChart('custom', `${label} Trend`, chartComponent);
    }
  };
  
  return (
    <div 
      className={`w-full flex justify-between items-center py-1.5 px-3 rounded transition-colors
        ${isMobile ? 'active:bg-slate-100 relative' : ''}
        ${className}`}
      onClick={isMobile ? handleClick : undefined}
    >
      <div className="font-semibold">{label}</div>
      <div className="flex items-center gap-2">
        <div className="font-medium">{value}</div>
        {isMobile && (
          <div className="text-xs text-blue-600">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
              <line x1="3" y1="9" x2="21" y2="9"/>
              <line x1="9" y1="21" x2="9" y2="9"/>
            </svg>
          </div>
        )}
      </div>
    </div>
  );
};

export default MetricTrigger; 